export default __webpack_public_path__ + "static/media/a1.dbd79216.JPG";